// extracted by mini-css-extract-plugin
export default {"loading":"LoadingScreen_loading__5Qh80","loadingTransparent":"LoadingScreen_loadingTransparent__hWYZ6","text":"LoadingScreen_text__QE5NZ"};